<template>

  <div>
    <!-- Filters -->
    <employees-list-filters
      :department-filter.sync="departmentFilter"
      :contract-filter.sync="contractFilter"
      :department-options="departmentOptions"
      :contract-options="contractOptions"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Afficher</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>Employés</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Rechercher..."
              />
              <b-button
                variant="primary"
                @click="addEmployee"
              >
                <span class="text-nowrap">Ajouter un Profil</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refEmployeeListTable"
        class="position-relative"
        :items="fetchEmployees"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Aucun enregistrment trouvé"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: Employee -->
        <template #cell(user)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.last_name + ' ' + data.item.first_name)"
                :variant="`light-${resolveEmployeeStatusVariant(data.item.contract_type)}`"
                :to="{ name: 'apps-employees-view', params: { id: data.item.uid } }"
              />
            </template>
            <b-link
              :to="{ name: 'apps-employees-view', params: { id: data.item.uid } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.last_name + ' ' + data.item.first_name }}
            </b-link>
            <small class="text-muted">#{{ data.item.matricule }}</small>
          </b-media>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveEmployeeStatusVariant(data.item.contract_type)}`"
          >
            {{ data.item.contract_type.toUpperCase() }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item :to="{ name: 'apps-employees-view', params: { id: data.item.uid } }">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Détails</span>
            </b-dropdown-item>

            <b-dropdown-item :to="{ name: 'apps-employees-edit', params: { id: data.item.uid } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Modifier</span>
            </b-dropdown-item>

            <b-dropdown-item>
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Supprimer</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Affichage de {{ dataMeta.from }} à {{ dataMeta.to }} sur {{ dataMeta.of }} Employés</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalEmployees"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { useRouter } from "@core/utils/utils";
import { ref, onMounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import EmployeesListFilters from './EmployeesListFilters.vue'
import useEmployeesList from './useEmployeesList'

export default {
  components: {
    EmployeesListFilters,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
  },
  setup() {
    const isAddNewEmployeeSidebarActive = ref(false)
    const { route, router } = useRouter();

    onMounted(() => {
      let props = ["departments"];
      fetchEmployeeProperties(props);
    });

    const {
      fetchEmployees,
      getWagesHistories,
      fetchEmployeeProperties,
      tableColumns,
      perPage,
      currentPage,
      totalEmployees,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refEmployeeListTable,
      refetchData,

      // UI
      resolveEmployeeStatusVariant,

      // Extra Filters
      departmentOptions,
      contractOptions,
      departmentFilter,
      contractFilter,
    } = useEmployeesList()

    const addEmployee = () => router.push({ name: 'apps-employees-add' })

    return {

      // Sidebar
      isAddNewEmployeeSidebarActive,

      fetchEmployees,
      getWagesHistories,
      tableColumns,
      perPage,
      currentPage,
      totalEmployees,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refEmployeeListTable,
      refetchData,
      addEmployee,

      // Filter
      avatarText,

      // UI
      resolveEmployeeStatusVariant,

      departmentOptions,
      contractOptions,

      // Extra Filters
      departmentFilter,
      contractFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>